import Vue from 'vue'
import Switch from './Switch'

Vue.component('ui-switch', Switch)
